const HeaderData = (jwtTokenJobcritic) => [
    {
        title: jwtTokenJobcritic ? '' : 'Home',
        link: jwtTokenJobcritic ? '' : '/'
    },
    {
        title: jwtTokenJobcritic ? 'Profile' : 'Professionals',
        link: jwtTokenJobcritic ? '/profile' : '/professionals'
    },
    {
        title: jwtTokenJobcritic ? 'Reviews' : 'Organizations',
        link: jwtTokenJobcritic ? '/reviews' : '/organizations'
    }
    
    // , {
    //     title: jwtTokenJobcritic ? '' : 'Blogs',
    //     link: jwtTokenJobcritic ? '/' : '/blogs'
    // }
];

export default HeaderData;